/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ColumnDto } from './column-dto';
/**
 *
 *
 * @export
 * @interface AggregateOperationDto
 */
export interface AggregateOperationDto {
  /**
   * Aggregate function
   *
   * @type {string}
   * @memberof AggregateOperationDto
   * @example count
   */
  aggregate_function: AggregateOperationDtoAggregateFunctionEnum;

  /**
   * Column to aggregate.
   *
   * @type {ColumnDto}
   * @memberof AggregateOperationDto
   */
  column: ColumnDto;
}

/**
 * @export
 * @enum {string}
 */
export enum AggregateOperationDtoAggregateFunctionEnum {
  Count = 'count',
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
  Avg = 'avg',
  CountDistinct = 'count_distinct',
}
